import { useReducer, useMemo } from 'react';

import reducer, { defaultState, LoadersState } from './reducer';
import { LoadersAction } from './actionTypes';

export interface LoadersActions {
    setLoader: (payload: LoadersAction) => void;
}

export interface SubscriptionLoadersState {
    loaders: LoadersState;
    actions: LoadersActions;
}

export default function useLoadersState(): SubscriptionLoadersState {
    const [state, dispatch] = useReducer(reducer, defaultState);
    const actions: LoadersActions = useMemo(
        () => ({
            setLoader: (payload: LoadersAction): void => dispatch(payload),
        }),
        [dispatch],
    );
    return useMemo(
        () => ({
            loaders: state,
            actions,
        }),
        [state, actions],
    );
}
